const prodUrl = process.env.REACT_APP_PROD_URL
const siteDevUrl = 'http://localhost:5003'
const siteProdUrl = process.env.SITE_URL
// export const apiUrl = process.env.API_URL || 'http://localhost:5003'

export const baseUrl = process.env.NODE_ENV === 'production' ? prodUrl : siteDevUrl
export const siteUrl = process.env.NODE_ENV === 'production' ? siteProdUrl : siteDevUrl